import { render, staticRenderFns } from "./Linking.vue?vue&type=template&id=029afed8"
import script from "./Linking.vue?vue&type=script&lang=js"
export * from "./Linking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports